const SESSION_ID_KEY = 'vm_survey_session_id';

let cached: string | null = null;

/**
 * The id Typeform receives as its `session_id` hidden field, stable for this
 * browser session (sessionStorage). Shared by the survey and the analytics
 * bootstrap, which registers it before Mixpanel sends its first event.
 */
export const getSurveySessionId = (): string => {
  if (cached) return cached;
  try {
    const existing = sessionStorage.getItem(SESSION_ID_KEY);
    if (existing) return (cached = existing);
    const id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_ID_KEY, id);
    return (cached = id);
  } catch {
    // Storage unavailable: still one id for the life of this page.
    return (cached = crypto.randomUUID());
  }
};
